module.exports = __webpack_public_path__ + "static/media/default_post_image.5b4c561f.png";